import { Grid, LinearProgress, Typography } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { NestedList } from '../../../../components/Display'
import { Application } from '../../../../types/applications'
import { Reservation } from '../../../../types/showings'
import ApplicationsList from '../../../Applications/ApplicationsList'
import { getDateTitle } from '../utils/dataHandling'

interface ReservationsListProps {
  reservations: Reservation[]
  applications: Application
  t: i18n.TFunction
  reservationsLoading: boolean
}

const ReservationsList: FC<ReservationsListProps> = ({
  reservations,
  t,
  reservationsLoading
}) => (
  <Grid item xs={12}>
    {reservationsLoading ? (
      <LinearProgress />
    ) : (
      <NestedList
        id='reservationsList'
        t={t}
        listName='nestedList'
        listItemText={
          <Typography variant='h5'>
            {t('showings.reservations.title')}
          </Typography>
        }
        NestedListChild={reservations.map((reservation: Reservation) => (
          <NestedList
            key={`${reservation.showingId}`}
            t={t}
            id={`${reservation.startDate}`}
            listName='reservationList'
            listItemText={getDateTitle(reservation)}
            NestedListChild={
              reservation.applications ? (
                <ApplicationsList
                  applications={reservation.applications}
                  t={t}
                />
              ) : (
                <LinearProgress />
              )
            }
          />
        ))}
      />
    )}
  </Grid>
)

export default ReservationsList
